// src/services/simulationService.js

// ⚠️ IMPORTANTE: Verifica qué dominio debes usar. 
// Si tu backend está en "api-dev", usa ese. "ws-prd" suena a producción.
  const BASE_URL = "https://ws-prd.enlaparadave.com/v1/websocket/simulation"; 

export const calculateBestRoute = async (simulationRequest, token) => {
  try {
    console.log("📤 Enviando datos de simulación...", simulationRequest);

    // Corregido: Ahora concatenamos correctamente el endpoint a la base
    const response = await fetch(`${BASE_URL}/calculate-best-route`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(simulationRequest),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log("📥 Resultado recibido:", data);
    return data;
    
  } catch (error) {
    console.error("❌ Error en la simulación:", error);
    throw error;
  }
};